import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"

import Style from "./style"
import PaymentList from "./ui/PaymentList"
import QuestionList from "./ui/QuestionList"

import MainHeader from "widget/MainHeader"

import useGetExamDetail from "entity/exam/useGetExamDetail"

import DTStyle from "shared/style/detailTableStyle"
import { convertProGradeAsName } from "shared/constant/lookup/proGrade"
import timestampCalculator from "shared/lib/timestampCalculator"

const TryoutExamDetail = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [examData] = useGetExamDetail()

    const btnList = [
        {
            "label": "이 버전으로 신규 버전 생성",
            "clickEvent": () => navigate(`/exam/${idx}/create`),
            "deactive": false
        }
    ]

    const examDataList = [
        {
            "label": "IDX",
            "value": examData?.data?.idx
        },
        {
            "label": "회차",
            "value": examData?.data?.version
        },
        {
            "label": "대상 프로 자격",
            "value": convertProGradeAsName[examData?.data?.pro_grade_flag]
        },
        {
            "label": "현재 활성 중인 버전",
            "value": examData?.data?.active ? "Yes" : "No"
        },
        {
            "label": "전체 문제 개수",
            "value": examData?.data?.question?.length
        },
        {
            "label": "커트라인 점수",
            "value": examData?.data?.cutoff
        },
        {
            "label": "생성 날짜",
            "value": timestampCalculator(examData?.data?.created_at)
        },
    ]

    const tabList = ["포함 문제", "결제자"]
    const [tab, setTab] = useState(tabList[0])

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <Style.AreaDiv>
                <h2>필기 시험 데이터</h2>
                <DTStyle.TableDiv>
                    {examDataList?.map(elem =>
                        <DTStyle.TableElement>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <Style.TabDiv>
                {tabList.map(elem => <Style.Tab $selected={tab === elem} onClick={() => setTab(elem)}>{elem}</Style.Tab>)}
            </Style.TabDiv>

            {tab === tabList[0] && <QuestionList questionList={examData?.data?.question} />}
            {tab === tabList[1] && <PaymentList />}

        </Style.Wrapper >
    )
}

export default TryoutExamDetail